/* bs-pro-faq — acordeón de "Preguntas frecuentes del canal profesional" (landing B2B).
   Cada ítem se abre/cierra de forma INDEPENDIENTE: no hay lógica de "cerrar los demás" al
   abrir uno nuevo. El primer ítem viene ABIERTO server-rendered (bs-pro-faq__item--open,
   aria-expanded "true", panel sin inert) — este script respeta ese estado inicial, solo ata
   los listeners de click.

   Animación por height (scrollHeight + doble rAF + transitionend), respeta
   prefers-reduced-motion. Mismo patrón que bs-product-faq.js. */

(function () {
  'use strict';

  var OPEN_CLASS = 'bs-pro-faq__item--open';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateOpen(item, trigger, panel) {
    panel.dataset.animating = 'true';
    item.classList.add(OPEN_CLASS);
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('inert'); // a11y: panel abierto vuelve al árbol de foco/AT

    if (reduceMotion) {
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var target = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function animateClose(item, trigger, panel) {
    panel.dataset.animating = 'true';
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('inert', ''); // a11y: panel cerrado fuera del árbol de foco/AT (inmediato)

    if (reduceMotion) {
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
      return;
    }

    var start = panel.scrollHeight;
    panel.style.height = start + 'px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
    });

    function onEnd(e) {
      if (e.target !== panel || e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      item.classList.remove(OPEN_CLASS);
      panel.style.height = '';
      panel.dataset.animating = '';
    }
    panel.addEventListener('transitionend', onEnd);
  }

  function initSection(section) {
    if (section.dataset.bsProFaqInit) return;
    section.dataset.bsProFaqInit = 'true';

    var list = section.querySelector('.bs-pro-faq__list');
    if (!list) return;

    list.addEventListener('click', function (event) {
      var trigger = event.target.closest('.bs-pro-faq__trigger');
      if (!trigger || !list.contains(trigger)) return;

      var item = trigger.closest('.bs-pro-faq__item');
      var panel = item && item.querySelector('.bs-pro-faq__panel');
      if (!item || !panel || panel.dataset.animating === 'true') return;

      var isOpen = item.classList.contains(OPEN_CLASS);

      /* Toggle independiente: NO se cierran otros ítems. */
      if (isOpen) {
        animateClose(item, trigger, panel);
      } else {
        animateOpen(item, trigger, panel);
      }
    });
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.bs-pro-faq-root');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bs-pro-faq-root');
    if (section) init(event.target);
  });
})();
